export default {
    buscar: "Buscar",
    categoria: "Categoría",
    sucursal: "Sucursal",
    depto: "Departamento/Área",
    asignado: "Asignado a",
    fechaIni: "Fecha de inicio",
    fechaFin: "Fecha de finalización",
    fechaPromIni: "Fecha prometida de inicio",
    fechaPromFin: "Fecha prometida de finalización",
    estado: "Estado",
    finalizadas: "Órdenes finalizadas",
    entregados: "Equipos entregados",
    desde: "Desde",
    hasta: "Hasta",
    fecha: "Fecha",
    tipoServicio: "Tipo de servicio",
    grado: "Grado",
    agendadoDesde: "Agendado desde",
    agendadoHasta: "Agendado hasta",
    origen: "Sucursal origen",
    destino: "Sucursal destino",
    usuario: "Usuario",
    obra: "Obra",
    nroInventario: "Nro. Inventario",
    codBarras: "Código de barras",
    

}